import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Row,
    Col,
    Modal,
    message,
    Spin,
    Button,
    Input,
    InputNumber,
} from 'antd';
import { connect } from 'react-redux';
import { dateConversion, timeConversion, getDateBetween, showDate } from '../../../utils';
import { getList, getTaskId, createResetPvShowAction, getPv,createSetTaskIdAction,resetPv } from './actions';

class ResetPv extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
          modifyNum:0,
        };
    }
    /*async componentWillReceiveProps() {
      console.log("aaaaaa",this.props.taskId);
      await this.props.getPvCount(this.props.taskId);
    }*/
    changeAddHide = () => {
        this.setState({
            ...this.state,
            'modifyNum':0,
        });
        this.props.resetPvStatus(false);
        this.props.clearTaskId();
    }
    changeNum = (e) => {
      this.setState({
          ...this.state,
          'modifyNum':e,
      });
    }
    submit = () => {
      this.props.resetPv(this.props.taskId,this.state.modifyNum);
      this.setState({
          ...this.state,
          'modifyNum':0,
      });
      this.props.resetPvStatus(false);
      this.props.clearTaskId();
    }
    render() {
        const { ListLoading,resetStatus,taskId,pvCount } = this.props;
        return (
                <Modal
                    title={'更改目标量'}
                    visible={resetStatus}
                    onCancel={() => this.changeAddHide()}
                    onOk={() => {
                        this.submit();
                    }}
                    footer={[
                      <Button key="back" size="large" onClick={this.changeAddHide}>取消</Button>,
                      <Button key="submit" type="primary" size="large"  onClick={this.submit}>
                        修改
                      </Button>,
                    ]}>
                    <Row>
                      任务Id&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{taskId}
                    </Row>
                    <br/>
                    <Row>
                      当前Pv值&nbsp;:&nbsp;&nbsp;{pvCount}
                    </Row>
                    <br/>
                    <Row>
                      修改Pv值&nbsp;:&nbsp;<InputNumber min={0} defaultValue={this.state.modifyNum} onChange={this.changeNum.bind(this)} />
                    </Row>
                </Modal>
        );
    }
}

const mapStateToProps = state => ({
    ListLoading: state.tasklist.ListStatus.loading,
    taskId: state.tasklist.taskId,
    resetStatus: state.tasklist.ListStatus.resetPvShow,
    pvCount: state.tasklist.pvCount,
});

const mapDispatchToProps = dispatch => ({
    getList: param => dispatch(getList(param)),
    resetPvStatus: status => dispatch(createResetPvShowAction(status)),
    getPvCount: (id) => dispatch(getPv(id)),
    clearTaskId: () => dispatch(createSetTaskIdAction(0)),
    resetPv: (id,num) => dispatch(resetPv(id,num)),

});

export default connect(mapStateToProps, mapDispatchToProps)((ResetPv));



// WEBPACK FOOTER //
// ./pages/task/tasklist/ResetPv.js